import { Client } from "@microsoft/microsoft-graph-client";

/**
 * Build a Graph client that uses the MSAL instance for tokens.
 */
export function getGraphClient(msalInstance, account) {
  return Client.initWithMiddleware({
    authProvider: {
      getAccessToken: async () => {
        const result = await msalInstance.acquireTokenSilent({
          scopes: ["https://graph.microsoft.com/.default"],
          account,
        });
        return result.accessToken;
      },
    },
  });
}
